import React, { FC } from 'react';
import { Link } from '@blueprint/ui';
import { Interpolate } from 'shared/i18n/Interpolate';

import triggerTracking from '@blueprint/tracking/dist/Tracking';

import RegisterForm from './RegisterForm';
import { TermsText } from './../../AuthModal.styles';
import { SocialAuthProps } from './../../AuthModal.types';

const termsAcceptanceTn =
    'By registering you accept our {{linebreak}} {{ termsLink }} and {{ privacyLink }}.';
const termsOfUseTn = 'Terms of Use';
const termsPrivacyPolicyTn = 'Privacy Policy';

const RegisterSection: FC<SocialAuthProps> = ({
    close,
    actionAfterAuth,
    resetActionAfterAuth,
    onSocialAuth
}) => (
    <>
        <RegisterForm
            close={close}
            actionAfterAuth={actionAfterAuth}
            resetActionAfterAuth={resetActionAfterAuth}
            onSocialAuth={onSocialAuth}
        />

        <TermsText size="secondary">
            <Interpolate
                template={termsAcceptanceTn}
                values={{
                    linebreak: <br key="linebreak" />,
                    termsLink: (
                        <Link
                            key="terms"
                            data-testid="terms-link"
                            href="/terms/"
                            onClick={() => {
                                triggerTracking({
                                    event: 'GAEvent',
                                    eventCategory: 'registration',
                                    eventAction: 'click_to_terms',
                                    eventLabel: actionAfterAuth?.eventLabel
                                });
                            }}
                        >
                            {termsOfUseTn}
                        </Link>
                    ),
                    privacyLink: (
                        <Link
                            key="privacy"
                            data-testid="privacy-link"
                            href="/privacy/"
                            onClick={() => {
                                triggerTracking({
                                    event: 'GAEvent',
                                    eventCategory: 'registration',
                                    eventAction: 'click_to_privacy',
                                    eventLabel: actionAfterAuth?.eventLabel
                                });
                            }}
                        >
                            {termsPrivacyPolicyTn}
                        </Link>
                    )
                }}
            />
        </TermsText>
    </>
);

export default RegisterSection;
